module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"supportFormat":"支持格式：pptx ppt dps pdf","chooseSubmit":"选择上传"}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/project/upload/index.vue
// module id = 343
// module chunks = 3